import { loadView } from '@/router'
import accounts from './accounts'
import assets from './assets'
import carriers from './carriers'
import edi from './edi'
import fuelLevies from './fuellevies'
import ratecards from './ratecards'
import schedulepickups from './schedulepickups'
import surcharges from './surcharges'
import users from './users'
import zones from './zones'

export default [
  {
    path: 'manage',
    name: 'manage',
    component: loadView('Application/Manage'),
    redirect: {
      name: 'manage-accounts'
    },
    children: [
      {
        path: 'dashboard',
        name: 'manage-dashboard',
        component: loadView('Application/Manage/Dashboard')
      },
      ...accounts,
      ...assets,
      ...carriers,
      ...edi,
      ...fuelLevies,
      ...ratecards,
      ...schedulepickups,
      ...surcharges,
      ...users,
      ...zones
    ]
  }
]
